import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

const MarqueeBand = ({ variant = 'default' }) => {
  const { language } = useLanguage();

  const VARIANTS = {
    default: {
      bg: 'bg-slate-900 border-y border-slate-800/60',
      dot: 'bg-cyan-500/50',
      text: 'text-slate-400',
      items: {
        es: ['Envíos CDMX 24-48 hrs', 'Telas Premium', 'Todas las Tallas', 'Mejores Precios', '100% Mehadrin', 'Soft Wool', 'Quality Cotton', 'Bamboo Smoothness', 'Dry-Fit', 'Adulto y Niño'],
        en: ['CDMX Shipping 24-48 hrs', 'Premium Fabrics', 'All Sizes', 'Best Prices', '100% Mehadrin', 'Soft Wool', 'Quality Cotton', 'Bamboo Smoothness', 'Dry-Fit', 'Adult & Kids'],
        he: ['משלוחים 24-48 שעות', 'בדים פרימיום', 'כל המידות', 'המחירים הטובים ביותר', '100% מהדרין', 'צמר רך', 'כותנה איכותית', 'רכות במבוק', 'דריי-פיט', 'מבוגרים וילדים'],
      },
    },
    merits: {
      bg: 'bg-slate-900 border-y border-slate-800',
      dot: 'bg-cyan-400/70',
      text: 'text-slate-300',
      items: {
        es: ['Equivale a todas las mitzvot', 'Amerita la Shejiná', 'Trae larga vida', 'Trae sabiduría', 'Anula el enojo', 'Escudo contra lashon hara', 'Protege contra Ayin hara'],
        en: ['Equivalent to all mitzvot', 'Merits the Shejina', 'Brings long life', 'Brings wisdom', 'Annuls anger', 'Shield against lashon hara', 'Protects against Ayin hara'],
        he: ['שקולה כנגד כל המצוות', 'מזכה בקבלת פני השכינה', 'מביאה אריכות ימים', 'מביאה חכמה', 'מבטלת את הכעס', 'מגן מפני לשון הרע', 'מגינה מעין הרע'],
      },
    },
    kashrut: {
      bg: 'bg-white border-y border-slate-200',
      dot: 'bg-green-500',
      text: 'text-slate-700',
      items: {
        es: ['100% Mehadrin', 'Certificado Kosher', 'Hilos Badatz Yerushalayim', 'Avodat Yad', 'Máxima Calidad'],
        en: ['100% Mehadrin', 'Kosher Certified', 'Badatz Yerushalayim Threads', 'Avodat Yad', 'Highest Quality'],
        he: ['100% מהדרין', 'תעודת כשרות', 'חוטי בד״ץ ירושלים', 'עבודת יד', 'איכות מקסימלית'],
      },
    },
    footer: {
      bg: 'bg-slate-950 border-t border-slate-800/40',
      dot: 'bg-cyan-400/40',
      text: 'text-slate-600',
      items: {
        es: ['Mitzva Fit', 'Elige Tu Tzitzit', 'A Higher Tzitzit Experience', 'Top Worldwide Fabrics', 'Hecho con devoción', 'Para toda la familia'],
        en: ['Mitzva Fit', 'Pick Your Tzitzit', 'A Higher Tzitzit Experience', 'Top Worldwide Fabrics', 'Made with devotion', 'For the whole family'],
        he: ['Mitzva Fit', 'בחר את הציצית שלך', 'חוויית ציצית ברמה אחרת', 'הבדים הטובים בעולם', 'נעשה במסירות', 'לכל המשפחה'],
      },
    },
  };

  const v = VARIANTS[variant] || VARIANTS.default;
  const items = v.items[language] || v.items.es;
  const doubled = [...items, ...items];

  return (
    <div className={`${v.bg} py-3 overflow-hidden`}>
      <div className="hero-marquee">
        <div className="hero-marquee-track">
          {doubled.map((item, i) => (
            <span key={i} className="flex items-center whitespace-nowrap mx-6 lg:mx-10">
              <span className={`w-1.5 h-1.5 rounded-full ${v.dot} mr-4 lg:mr-6 flex-shrink-0`} />
              <span className={`text-xs lg:text-sm ${v.text} font-medium tracking-wide uppercase`}>
                {item}
              </span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarqueeBand;
